import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme) => ({
  title: {
    color: "#3D3D3D",
    fontSize: "14px",
    fontWeight: "600",
    margin: "0px",
    padding: "10px 0px 4px 0px",
  },
}));
